const apiRoute = process.env.REACT_APP_API_ROUTE;
const metadataRoute = process.env.REACT_APP_METADATA_ROUTE;
const tobleroneRoute = process.env.REACT_APP_TOBLERONE_ROUTE;
const newsletterRoute = process.env.REACT_APP_NEWSLETTER_ROUTE;

export const COLLECTIONS_URL = `${apiRoute}api/v1/collections`;
export const TRANSACTIONS_URL = `${apiRoute}api/v1/events{address}`;
export const COLLECTION_DETAILS_URL = `${apiRoute}api/v1/collections/`;
export const TRANSACTION_FOR_COLLECTION_URL = `${apiRoute}api/v1/events{address}?collection=`;
export const USER_ADDRESSES = `${apiRoute}api/v1/user/get/`;
export const WALLET_BALANCE = `${apiRoute}api/v1/balances/`;
export const USER_GAMES = `${apiRoute}api/v1/user{address}/app/`;
export const CAROUSELS = `${apiRoute}api/v1/collections/carousels`;
export const WITHDRAW_VERIFY_URL = `${apiRoute}api/v1/firstOasis/withdrawVerify`;
export const WITHDRAW_URL = `${apiRoute}api/v1/firstOasis/withdraw`;
export const CARDS_METADATA_URL = `${metadataRoute}cards`;
export const DEPOSIT_URL = `${tobleroneRoute}bearwhale/api/firstOasis/depositExecutor/user/`;
export const NEWSLETTER_URL = `${newsletterRoute}`;
